import axios from '../../../localAxios';
import { workspaceOwnershipURL } from '../../workspacesURLs';

interface TransferOwnershipProps {
  workspaceId: string;
  userId: string;
}

export async function transferWorkspaceOwnership({
  workspaceId,
  userId,
}: TransferOwnershipProps) {
  const result = await axios.put(workspaceOwnershipURL(workspaceId).href, {
    new_owner_id: userId,
  });
  return result.data;
}
